import api from './apiHelper';

export const getConstants = name => {
  return api.get(`/constant/${name}`);
};

